import { useEffect, useRef } from 'react'

import Styles from './HandbookSettings.module.scss'
import { SettingsSectionProps } from './Types'
import { useIntersectionObserver } from 'hooks/useIntersectionObserver'

export const SettingsSection = ({ children, tab, onIntersect, parentRef, isFirst = false }: SettingsSectionProps) => {
  const ref = useRef<HTMLDivElement>(null)
  const entry = useIntersectionObserver(ref, {
    threshold: 0.1,
    root: parentRef.current,
    rootMargin: '-10% 0px -70% 0px',
  })

  useEffect(() => {
    if (entry?.isIntersecting) onIntersect()
  }, [entry?.isIntersecting, onIntersect])

  return (
    <>
      <div className={Styles.section} ref={ref}>
        {children}
      </div>
    </>
  )
}
